<h2 class="_sansSerif _primary"[i18nKey]="'intro.menus.title'"></h2>

<kiwi-spacer [size]="24"></kiwi-spacer>

<p [i18nKey]="'intro.menus.paragraph.1'"></p>
<div class="grid-x grid-margin-x">
    <fieldset class="cell small-12 introductionFieldset">
        <legend [i18nKey]="'intro.menus.element.1'"></legend>

        <ul>
            <li [i18nKey]="'intro.menus.element.2'"></li>
            <li [i18nKey]="'intro.menus.element.3'"></li>
            <li [i18nKey]="'intro.menus.element.4'"></li>
            <li [i18nKey]="'intro.menus.element.5'"></li>
        </ul>
    </fieldset>
    <fieldset class="cell small-12 introductionFieldset">
        <legend [i18nKey]="'intro.menus.element.6'"></legend>

        <ul>
            <li [i18nKey]="'intro.menus.element.7'"></li>
            <li [i18nKey]="'intro.menus.element.8'"></li>
            <li [i18nKey]="'intro.menus.element.9'"></li>
        </ul>
    </fieldset>
</div>

<kiwi-spacer [size]="16"></kiwi-spacer>

<h3 [i18nKey]="'intro.menus.subtitle.1'"></h3>
<p [i18nKey]="'intro.menus.paragraph.2'"></p>
<p [i18nKey]="'intro.menus.paragraph.3'"></p>

<kiwi-spacer [size]="16"></kiwi-spacer>

<h3 [i18nKey]="'intro.menus.subtitle.2'"></h3>
<p [i18nKey]="'intro.menus.paragraph.4'"></p>
<p [i18nKey]="'intro.menus.paragraph.5'"></p>

<kiwi-spacer [size]="16"></kiwi-spacer>

<h3 [i18nKey]="'intro.menus.subtitle.3'"></h3>
<p [i18nKey]="'intro.menus.paragraph.6'"></p>
<p [i18nKey]="'intro.menus.paragraph.7'"></p>
<p [i18nKey]="'intro.menus.paragraph.8'"></p>
<p [i18nKey]="'intro.menus.paragraph.9'"></p>
